module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDggMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCAxMS45NzI1TDYuNDc3NzMgMTMuNUwwIDdMNi40Nzc3MyAwLjVMOCAyLjAyNzVMMy4wNTUzMyA3TDggMTEuOTcyNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic_back_white.svg
// module id = aqX2
// module chunks = 0